import { render, staticRenderFns } from "./DetailBarangEmas.vue?vue&type=template&id=5b0735b2&scoped=true&"
import script from "./DetailBarangEmas.vue?vue&type=script&lang=js&"
export * from "./DetailBarangEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0735b2",
  null
  
)

export default component.exports